// removed by extract-text-webpack-plugin
module.exports = {"header":"SubmissionPanelHeader__header___3MPHb layout__panel___vsQZV","logo":"SubmissionPanelHeader__logo___1x60s","logoLeft":"SubmissionPanelHeader__logoLeft___Wo8R3 SubmissionPanelHeader__logo___1x60s","logoRight":"SubmissionPanelHeader__logoRight___2Q9A0 SubmissionPanelHeader__logo___1x60s"};


//////////////////
// WEBPACK FOOTER
// ./src/submission/components/SubmissionPanelHeader.css
// module id = 768
// module chunks = 0